import React from "react";

export const adminBtnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-sm bg-ink px-5 py-2.5 font-sans text-sm font-medium text-cream-100 transition-colors hover:bg-steel-600 disabled:opacity-60";
export const adminBtnGhost =
  "inline-flex items-center justify-center gap-2 rounded-sm border border-ink/15 px-5 py-2.5 font-sans text-sm font-medium text-ink transition-colors hover:border-gold-500 hover:text-gold-600";
export const adminField =
  "mt-1.5 w-full rounded-sm border border-ink/20 bg-white px-3.5 py-2.5 font-sans text-sm text-ink focus:border-gold-500 focus:outline-none";
export const adminLabel = "font-sans text-sm font-medium text-ink";

const styles = {
  published: "bg-emerald-100 text-emerald-700",
  draft: "bg-cream-200 text-steel-600",
  scheduled: "bg-amber-100 text-amber-700",
  new: "bg-gold-500/20 text-gold-600",
  read: "bg-cream-200 text-steel-500",
  archived: "bg-cream-200 text-steel-400",
};

export function StatusBadge({ status }) {
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 font-sans text-xs font-medium capitalize ${styles[status] || styles.draft}`}>
      {status}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="font-serif text-3xl font-light text-ink">{title}</h1>
        {subtitle && <p className="mt-1 font-sans text-sm text-steel-500">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-3">{children}</div>}
    </div>
  );
}
